import { ProblemDetails } from "src/models/ProblemDetails";

export const formatString = (str: string, ...args: any) => {
    return str.replace(/{(\d+)}/g, (match, number) => typeof args[number] != 'undefined' ? args[number] : match);
}

export const isEmptyOrNull = (str: string | null): boolean => {
    return str === null || str === "";
}

export const extractErrorMessageFromProblemDetails = (problemDetails: ProblemDetails): string => {
    if (!problemDetails.errors || Object.keys(problemDetails.errors).length === 0) {
        return problemDetails.title;
    }

    let message = '';
    Object.keys(problemDetails.errors).forEach(key => message += problemDetails.errors[key]);

    return message;
}

export const extractErrorMessagesFromProblemDetails = (problemDetails: ProblemDetails): string[] => {
    if (!problemDetails.errors || Object.keys(problemDetails.errors).length === 0) {
        return [problemDetails.title]
    }

    return Object.keys(problemDetails.errors).map(key => problemDetails.errors[key]);
}

export const truncateString = (str: string, maxLength: number = 15) => {
    return str.length > maxLength
      ? str.substring(0, maxLength) + "..."
      : str;
  };